import { render } from "./MapMarkerYellowIcon.vue?vue&type=template&id=89dab92e"
import script from "./MapMarkerYellowIcon.vue?vue&type=script&lang=js"
export * from "./MapMarkerYellowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__